import { render } from "./Inventory.vue?vue&type=template&id=210ca3bc"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/Inventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "210ca3bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('210ca3bc', __exports__)) {
    api.reload('210ca3bc', __exports__)
  }
  
  module.hot.accept("./Inventory.vue?vue&type=template&id=210ca3bc", () => {
    api.rerender('210ca3bc', render)
  })

}


export default __exports__